// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pJ{width:299px}.pJ svg{width:15px;height:15px}.pJ:hover{opacity:.7}", "",{"version":3,"sources":["webpack://./src/AuthPage/AuthOtherServices/Facebook/Facebook.module.scss"],"names":[],"mappings":"AAAA,IACE,WAAA,CAEA,QACE,UAAA,CACA,WAAA,CAIJ,UACE,UAAA","sourcesContent":[".facebookContainer {\r\n  width: 299px;\r\n\r\n  svg {\r\n    width: 15px;\r\n    height: 15px;\r\n  }\r\n}\r\n\r\n.facebookContainer:hover{\r\n  opacity: 0.7;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"facebookContainer": "pJ"
};
export default ___CSS_LOADER_EXPORT___;
